import {
  TRACK_MEAL_CARD_MODAL_OPEN,
  TRACK_MEAL_CARD_ISSUER_CLICK,
  TRACK_MEAL_CARD_AUTH_SUCCESS,
  TRACK_CLICKED_MEAL_CARD_BANNER,
} from './types';

export function trackMealCardModalOpen() {
  return {
    type: TRACK_MEAL_CARD_MODAL_OPEN,
    payload: {
      name: 'Viewed choose TR issuer',
      properties: {
        tr_event_id: 2,
        issuer: 'all',
      },
    },
  };
}

export function trackIssuerClick(issuer) {
  return {
    type: TRACK_MEAL_CARD_ISSUER_CLICK,
    payload: {
      name: `Tapped issuer ${issuer}`,
      properties: {
        tr_event_id: 3,
        issuer,
      },
    },
  };
}

// eslint-disable-next-line camelcase
export function trackMealCardAuthSuccess({ name, issuer, tr_event_id }) {
  return {
    type: TRACK_MEAL_CARD_AUTH_SUCCESS,
    payload: {
      name,
      properties: {
        tr_event_id,
        issuer,
      },
    },
  };
}

export function trackClickedMealCardBanner() {
  return {
    type: TRACK_CLICKED_MEAL_CARD_BANNER,
    payload: {
      name: 'Tapped Add Titre Restaurant card banner',
      properties: {
        tr_event_id: 1,
        issuer: 'all',
      },
    },
  };
}
